module.exports = __webpack_public_path__ + "static/img/monitor-img.c646aa5c.png";